import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SvgIcon, SvgIconComponent } from '@web/shared/ui';

@Component({
  selector: 'app-footer-icon',
  imports: [SvgIconComponent],
  templateUrl: './footer-icon.component.html',
  styleUrl: './footer-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterIconComponent {
  public readonly icon = input.required<SvgIcon>();
}
